import { render } from "./cannedResponses.vue?vue&type=template&id=3521ccb9"
import script from "./cannedResponses.vue?vue&type=script&lang=js"
export * from "./cannedResponses.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__